module.exports = __webpack_public_path__ + "static/media/logo.ba1ddebc.png";